import useId from '../utils/useId';
import * as React from 'react';
export const satispaySvg = React.forwardRef(function satispaySvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#pm_satispay__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M3.023 0h5.224l7.1 6.5c.411.377.653.906.653 1.457a2.019 2.019 0 0 1-.626 1.458l-7.11 6.574H3.006a.221.221 0 0 1-.123-.036.212.212 0 0 1-.08-.098.205.205 0 0 1 .055-.232l8.295-7.463a.253.253 0 0 0 .078-.181.254.254 0 0 0-.082-.18L2.875.366c-.148-.127-.05-.365.148-.365ZM.637 9.41a2.055 2.055 0 0 1-.47-.672A2.007 2.007 0 0 1 0 7.942C0 7.39.24 6.86.653 6.484l3.814-3.51L7.33 5.561 4.845 7.778a.25.25 0 0 0-.077.18c0 .069.033.132.082.18l2.514 2.258-2.865 2.588L.637 9.41Zm8.9 6.59h3.494c.198 0 .297-.239.149-.366l-1.641-1.479L9.536 16ZM13.151.366l-1.624 1.452L9.53 0h3.473c.044 0 .087.012.124.036a.206.206 0 0 1 .025.33Z',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `pm_satispay__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M0 0h16v16H0z',
        }),
      ),
    ),
  );
});
satispaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var satispay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'satispay',
  svg: satispaySvg,
};
